export const selectEstates = state => state.estates.list
export const selectEstatesMeta = state => state.estates.meta
export const selectEstatesLoading = state => state.estates.loading
export const selectEstatesSaving = state => state.estates.saving
